<template>
  <div class="teams-container">
    <ul class="wrapper" v-if="team">
      <li class="member" v-for="(member, i) in team.slice(0, 3)" :key="i">
        <v-avatar color="grey lighten-5" :size="size">
          <img :src="getImageUrl(member.id)" alt="Img" />
        </v-avatar>
      </li>
      <li class="member" v-if="team.length > 3">
        <v-avatar color="grey darken-4" :size="size">
          <span class="white--text">+{{team.length-3}}</span>
        </v-avatar>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "TeamView",
  props: {
    team: Array,
    size: Number
  },
  methods: {
    getImageUrl(id) {
      return "https://api.adorable.io/avatars/" + id;
    }
  }
};
</script>

<style scoped>
.wrapper {
  list-style: none;
  margin: 0px;
  padding: 0px;
  display: flex;
  flex-direction: row;
}

.member {
  width: 15px;
}

.v-avatar {
  border: 2px solid white;
}
</style>